import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../components/W3Dropdown";
import { PrimaryButton, ButtonLink } from "../../../components/Buttons";
import PasswordChangeForm from "../../Login/containers/PasswordChangeForm";
import BasicDataChangeForm from "../../Login/containers/BasicDataChangeForm";

const MODETYPES = {
  DEFAULT: 1,
  EDITING_DATA: 2,
  EDITING_PASSWORD: 3,
};

function BasicProfileDataMenu({ className = "" }) {
  const [mode, setMode] = React.useState(MODETYPES.DEFAULT);

  const onEditData = React.useCallback((event) => {
    if (event) event.preventDefault();
    setMode(MODETYPES.EDITING_DATA);
  }, []);

  const onChangePassword = React.useCallback((event) => {
    if (event) event.preventDefault();
    setMode(MODETYPES.EDITING_PASSWORD);
  }, []);

  const onHide = React.useCallback(() => {
    setMode(MODETYPES.DEFAULT);
  }, []);

  let data = null;
  switch (mode) {
    case MODETYPES.EDITING_DATA:
      data = {
        title: <h3 className="no-margin">{`Profiledaten bearbeiten`}</h3>,
        body: <BasicDataChangeForm onClose={onHide} />,
      };
      break;
    case MODETYPES.EDITING_PASSWORD:
      data = {
        title: <h3 className="no-margin">{`Passwort ändern`}</h3>,
        body: <PasswordChangeForm onClose={onHide} />,
      };
      break;
    default:
      break;
  }

  const style = { width: "400px" };
  const dialog = data && (
    <Dialog
      header={
        <div
          className="bg-secondary-"
          style={{ margin: "-1em", padding: "1em" }}
        >
          {data.title}
        </div>
      }
      visible
      style={style}
      modal
      onHide={onHide}
    >
      {data.body}
    </Dialog>
  );

  return (
    <div>
      <W3Dropdown className="modems dropdown-list-menu">
        <W3DropdownToggler
          as={PrimaryButton}
          size="small"
        >{`Optionen`}</W3DropdownToggler>
        <W3DropdownContent
          className="w3-bar-block w3-border"
          style={{ right: "0", width: "180px" }}
        >
          {/* <ButtonLink to="#"
            className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
            onClick={onEditData}>
              {`Profil bearbeiten`}
          </ButtonLink> */}
          <ButtonLink
            to="#"
            className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
            onClick={onChangePassword}
          >
            {`Passwort ändern`}
          </ButtonLink>
        </W3DropdownContent>
      </W3Dropdown>
      {dialog}
    </div>
  );
}

BasicProfileDataMenu.propTypes = {
  className: PropTypes.string,
};

export default BasicProfileDataMenu;
